<template>
  <v-flex xs12 md6 class="pa-2">
    <v-layout align-baseline :style="{ margin: '-4px' }">
      <v-flex xs4 class="pa-1 font-weight-bold text-xs-right"> {{ label }}: </v-flex>
      <v-flex xs8 class="pa-1">
        <slot />
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/components/document/DocumentDescriptionItem.vue